
export const adminGroupsGet = (data) => {
    return data.data
}
export const adminGroupPost = (data) => {
    return data.data
}
export const adminGroupPatch = (data) => {
    return data.data
}
export const adminGroupDeleteApi = (data) => {
    return data.data
}
export const contact_group_contact_create_post = (data) => {
    return data.data
}
export const contact_group_contact_remove_api = (data) => {
    return data.data
}
export const getMembersListData = (data) => {
    return data.data
}
export const ContactsListingGet = (data) => {
    return data.data
}
export const getUserListData = (data) => {
    return data.data
}
export const adminGroupMappingGet = (data) => {
    return data.data
}
export const organisationGet = (data) => {
    return data.data
}
export const userPost = (data) => {
    return data.data
}
export const userPatch = (data) => {
    return data.data
}

export const userRelationDetailsGet = (userRelationdata) => {
    return userRelationdata.data
}

export const userDeleteApi = (data) => {
    return data.data
}

export const checkUserLimitGet = (data) => {
    return data.data
}
export const getOrgBranchListGet = (data) => {
    return data.data
}

export const role_list_get = (data) => {
    return data.data
}


